(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paula-delivery"] && !Shopify.designMode) return;
  try {
    if (!window.paulaDeliveryReady) {
  window.paulaDeliveryReady = true;
  const openers = new WeakMap();
  const overflow = new WeakMap();
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-delivery-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.deliveryOpen);
      if (!dialog || dialog.open) return;
      openers.set(dialog, opener);
      overflow.set(dialog, document.documentElement.style.overflow);
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = overflow.get(dialog) || '';
          openers.get(dialog)?.focus({preventScroll: true});
        });
      }
    }
    const closer = event.target.closest('[data-delivery-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.paula-delivery-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const zoneButton = event.target.closest('[data-delivery-zone]');
    if (zoneButton) {
      const box = zoneButton.closest('.paula-delivery-legacy');
      box.querySelectorAll('[data-delivery-zone]').forEach(b => { b.setAttribute('aria-pressed', String(b === zoneButton)); b.classList.toggle('is-active', b === zoneButton); });
      box.querySelectorAll('[data-delivery-summary]').forEach(p => {p.hidden = p.dataset.deliverySummary !== zoneButton.dataset.deliveryZone;});
      const dialog = document.getElementById(box.querySelector('[data-delivery-open]').dataset.deliveryOpen);
      dialog.querySelectorAll('[data-region]').forEach(d => {d.open = d.dataset.region === zoneButton.dataset.deliveryZone;});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
